export const TID = {
  // landing
  landing: {
    nav: "landing-nav",
    logo: "landing-logo",
    ctaLogin: "landing-cta-login",
    ctaRegister: "landing-cta-register",
    ctaAmbassador: "landing-cta-ambassador",
    hero: "landing-hero",
    ctaHeroPrimary: "landing-hero-cta-primary",
    ctaHeroSecondary: "landing-hero-cta-secondary",
    audienceFounder: "audience-founder",
    audienceCommunity: "audience-community",
    audienceAmbassador: "audience-ambassador",
    steps: "how-it-works",
    pricingAnnualToggle: "pricing-annual-toggle",
    pricingCard: "pricing-card",
    pricingCtaFounder: "pricing-cta-founder",
    footer: "landing-footer",
  },
  // auth
  auth: {
    loginEmail: "login-email",
    loginPassword: "login-password",
    loginSubmit: "login-submit",
    loginError: "login-error",
    loginForgot: "login-forgot",
    loginRegister: "login-register-link",
    registerName: "register-name",
    registerEmail: "register-email",
    registerPassword: "register-password",
    registerRoleFounder: "register-role-founder",
    registerRoleCommunity: "register-role-community",
    registerConsentTerms: "register-consent-terms",
    registerConsentMarketing: "register-consent-marketing",
    registerSubmit: "register-submit",
    registerError: "register-error",
    verifyStatus: "verify-status",
    forgotEmail: "forgot-email",
    forgotSubmit: "forgot-submit",
    resetPassword: "reset-password",
    resetSubmit: "reset-submit",
  },
  // shell
  shell: {
    topNav: "shell-top-nav",
    topLogo: "shell-top-logo",
    roleSwitcher: "shell-role-switcher",
    avatarMenu: "shell-avatar-menu",
    logout: "shell-logout",
    leftRail: "shell-left-rail",
    main: "shell-main",
    footer: "shell-footer",
    verifyBanner: "shell-verify-banner",
  },
  dashboard: {
    founderHome: "founder-home",
    communityHome: "community-home",
    adminHome: "admin-home",
    ambassadorHome: "ambassador-home",
  },
  settings: {
    gdprExport: "settings-gdpr-export",
    gdprErase: "settings-gdpr-erase",
    addRole: "settings-add-role",
  },
};
